import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import url from "../../function/url";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import UnemployedNavbar from "./UnemployedNavbar";

function UnemployedSuggestion() {
    const ID = Cookies.get("log_id");
    const navigate = useNavigate();
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });

    // State for existing fields and new fields
    const [name, setName] = useState("");
    const [contact, setContact] = useState("");
    const [email, setEmail] = useState("");
    const [parent, setParent] = useState("");  // This will hold Parent Details
    const [typeofProblem, setTypeofProblem] = useState("");
    const [problemStatement, setProblemStatement] = useState("");
    const [careerStatus, setCareerStatus] = useState("");

    function FetchSuggestiondetails() {
        axios
            .get(`${url.path}/fetch_suggestion_details/${ID}/`)
            .then((res) => {
                if (res.data.status) {
                    var emp = res.data.profile;
                    // Fetch the new fields and set their state
                    setName(emp.Candidate_Name);
                    setEmail(emp.Email);
                    setContact(emp.Contact);
                    setParent(emp.Parent_Details);  // Set Parent Details from the fetched data
                }
            })
            .catch((err) => {
                console.log("ERROR", err);
            });
    }

    useEffect(() => {
        if (ID) {
            FetchSuggestiondetails();  
        }
    }, [ID]);

    function Update_SuggestionProfile(e) {
        e.preventDefault();

        // Basic form validation
        if (!typeofProblem || !problemStatement || !careerStatus) {
            Toast.fire({
                icon: 'error',
                title: 'All fields are required!',
            });
            return;
        }

        // Prepare form data including Parent_Details
        const formdata = {
            name: name,
            email: email,
            contact: contact,
            parent: parent,  // Include Parent_Details
            Typeof_problem: typeofProblem,
            Problem_statement: problemStatement,
            Career_status: careerStatus,
        };

        axios
            .post(`${url.path}/update_suggestionprofile/${ID}/`, formdata)  // Include ID in the URL
            .then((res) => {
                if (res.data.status === 'success') {
                    Toast.fire({
                        icon: 'success',
                        title: 'Request Submitted Successfully..',
                    });
                    navigate("/unemployed_home"); // Redirect to home after successful update
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: res.data.message || "Something went wrong",
                    });
                }
            })
            .catch((err) => {
                Toast.fire({
                    icon: 'error',
                    title: err.response ? err.response.data.message : "Something went wrong",
                });
            });
    }

    return (
        <>
            <UnemployedNavbar />

            <div className="content">
                <div className="form-container">
                    <div id="ndiv">
                        <h1 style={{ fontSize: '30px' }}>Suggestion and Counselling</h1>
                    </div>
                    <center>
                        <h3 style={{ fontSize: '25px' }} className="uppercase">{name}</h3>
                    </center>
                    <br />
                    <form onSubmit={Update_SuggestionProfile}>
                        <div className="form-group-row mt-4">
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required readOnly

                                />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required        readOnly

                                />
                            </div>
                        </div>
                        <div className="form-group-row">
                            <div className="form-group">
                                <label>Contact</label>
                                <input
                                    type="text"
                                    value={contact}
                                    onChange={(e) => setContact(e.target.value)}
                                    required        readOnly

                                />
                            </div>
                            <div className="form-group">
                                <label>Parent Details</label>
                                <input
                                    type="text"
                                    value={parent}
                                    onChange={(e) => setParent(e.target.value)}  // Capture Parent Details
                                    />
                            </div>
                        </div>

                        <div className="form-group-row mt-4">
                            <div className="form-group">
                                <label>Type of Problem</label>
                                <select
                                    value={typeofProblem}
                                    onChange={(e) => setTypeofProblem(e.target.value)}
                                    required
                                >
                                    <option value="">Select Type of Problem</option>
                                    <option value="Job Hunt">Job Hunt</option>
                                    <option value="Career Guidance">Career Guidance</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Employment or Career Status</label>
                                <select
                                    value={careerStatus}
                                    onChange={(e) => setCareerStatus(e.target.value)}
                                    required
                                >
                                    <option value="">Select Career Status</option>
                                    <option value="Working">Working</option>
                                    <option value="Self-Employed">Self-Employed</option>
                                    <option value="Resigned">Resigned</option>
                                    <option value="On Leave">On Leave</option>
                                    <option value="Freelancing">Freelancing</option>

                                    {/* Add more career status options as needed */}
                                </select>
                            </div>
                        </div>
                        <div className="form-group-row">
                            <div className="form-group">
                                <label>Problem Statement</label>
                                <textarea
                                    value={problemStatement}
                                    onChange={(e) => setProblemStatement(e.target.value)}
                                    required
                                    rows="4"  // Optional: Adjust the height of the textarea
                                    cols="50" // Optional: Adjust the width of the textarea
                                    style={{ borderColor: 'gray', borderWidth: '1px', borderStyle: 'solid',borderRadius: '5px' }}
                                />
                            </div>
                        </div>

                        <center>
                            <div className="row">
                                <button
                                    style={{
                                        width: '150px',
                                        height: '40px',
                                        borderRadius: '10px',
                                        color: 'black',
                                        backgroundColor: 'gainsboro'
                                    }}
                                    type="submit"
                                >
                                    Request
                                </button>
                            </div>
                        </center>
                    </form>
                </div>
            </div>
        </>
    );
}

export default UnemployedSuggestion;